var negators = require('./negators.json');

module.exports = {
    apply: function(tokens, cursor, tokenScore) {
        if (cursor > 0) {
            var prevtoken = tokens[cursor - 1];
            if (negators[prevtoken]) {
                tokenScore = -tokenScore;
            }
        }
        return tokenScore;
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/sentiment/languages/en/scoring-strategy.js
// module id = 3244
// module chunks = 0